//#region Styles
import { Container } from "./styles";
//#endregion
//#region Images
import ErrorIcon from "icons/ErrorIcon";
//#endregion

const ErrorMessage = ({
    text,
    error 
}) => {
    return (text && error) ? (
        <Container>
            <div>
                <ErrorIcon/>
            </div>
            <span>{text}</span>
        </Container>
    ) : null;
}

export default ErrorMessage;